import { ChangeDetectionStrategy, Component, inject, Input, ViewChild } from '@angular/core';
import { TableComponent } from '@app/modules/table/table.component';
import { IButton } from '@app/modules/table/table.interface';
import { PopupContentComponent } from '@components/popup-content/popup-content.component';
import { LANG_DICTIONARY_TOKEN } from '@constants/diConstant';
import { IMainLang } from '@interfaces/languages/main-lang';
import { map } from 'rxjs/operators';

@Component({
    selector: 'fui-table-header',
    templateUrl: './table-header.component.html',
    styleUrls: ['../styles/table-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableHeaderComponent {
    readonly dictionary: IMainLang = inject(LANG_DICTIONARY_TOKEN);
    readonly table: TableComponent = inject(TableComponent, { host: true });
    @ViewChild(PopupContentComponent) contextMenu: PopupContentComponent;

    contextMenuX = 0;
    contextMenuY = 0;

    readonly globalMenuButtons$ = this.table.globalMenuButtons$.pipe(
        map((list) => list.filter((x) => x.isButtonsPanel !== true)),
    );

    readonly globalMenuButtonsPanel$ = this.table.globalMenuButtons$.pipe(
        map((list) => list.filter((x) => x.isButtonsPanel === true)),
    );

    readonly hasGlobalButtons$ = this.table.globalButtons$.pipe(map((list) => list.length > 0));

    readonly hasGlobalMenuButtons$ = this.globalMenuButtons$.pipe(map((list) => list.length > 0));

    readonly hasGlobalMenuButtonsPanel$ = this.globalMenuButtonsPanel$.pipe(map((list) => list.length > 0));

    /**
     * Флаг индикации того, что родительская таблица ещё грузится.
     * В этом режиме мы показываем заголовок, но выводим скелетон на месте кнопок.
     */
    @Input() isLoading = true;

    /** Принудительное отображение панели кнопок */
    @Input() forceButtonPanel: boolean;
    openContextMenu(event: MouseEvent): void {
        this.contextMenuX = event.clientX;
        this.contextMenuY = event.clientY;
        this.contextMenu.show(this.contextMenuX, this.contextMenuY);
    }

    /** Обработка клика меню */
    onMenuClick(button: IButton, $event: any) {
        if (button.click) {
            this.table.callParent(
                button.click,
                button.records === 'one' ? this.table.selection.selected[0] : this.table.selection.selected,
                $event,
            );
        }
        this.contextMenu?.hide();
    }
}
